import audio from '../audio';

function handleCurrentTime(value) {
  audio.currentTime = Math.round((value * audio.duration) / 100);
}

export default handleCurrentTime;
